// Pre-compute resolution arrays
const SDXL_RESOLUTIONS = [
  { value: 10, string: "2:3" },
  { value: 11, string: "3:2" },
  { value: 7, string: "1:1" },
  { value: 8, string: "3:4" },
  { value: 9, string: "4:3" },
];

const STANDARD_RESOLUTIONS = [
  { value: 1, string: "2:3" },
  { value: 2, string: "3:2" },
  { value: 3, string: "1:1" },
  { value: 4, string: "3:4" },
  { value: 5, string: "4:3" },
  { value: 6, string: "16:9" },
];

// Simple lookup function
export function getResolutions(isSDXL: boolean) {
  return isSDXL ? SDXL_RESOLUTIONS : STANDARD_RESOLUTIONS;
}
